import * as S from './style';

import * as T from '../Typography';
import Markdown from '../Markdown';

const Tip = ({
  text,
  ShowBoldTipPrefix,
  customPrefix,
  coachNotesStyle,
  variant = 'primary',
  ...props
}) => {
  const textColor = variant === 'primary' ? 'primaryMain' : '#AC270A';
  if (text)
    return (
      <S.TipWrapper variant={variant} {...props}>
        <Markdown
          text={
            ShowBoldTipPrefix ? `**${customPrefix || 'Tip'}!** ${text}` : text
          }
          coachNotesStyle={coachNotesStyle}
          customStyles={{
            p: {
              mt: 3,
              ml: 4,
              mr: 4,
              mb: 3,
              color: textColor,
            },
            li: {
              color: 'primaryMain',
            },
          }}
        />
      </S.TipWrapper>
    );
  return props?.children?.map((e, index) => (
    <S.TipWrapper {...props} key={index}>
      <T.P display="inline" color={textColor} mt={3} ml={4} mr={4} mb={3}>
        {ShowBoldTipPrefix && 'Tip!'} <S.Content>{e}</S.Content>
      </T.P>
    </S.TipWrapper>
  ));
};

export default Tip;
